import React from "react";
import styled from "styled-components";

export default styled.a`
    ${(props) => (props.isDisabled ? {
    'background': 'gray !important',
    'cursor': 'not-allowed !important'
} : '')}
`;